export default "__VITE_ASSET__Bb04KHlE__"